import { InjectionToken } from "@angular/core";

import { CefiClient } from "@cloudextend/cefi/core";

export const ECOSYSTEMCLIENT = new InjectionToken<CefiClient>("ECOSYSTEMCLIENT");